import { render, staticRenderFns } from "./SearchCardItem.vue?vue&type=template&id=6a213695&scoped=true"
import script from "./SearchCardItem.vue?vue&type=script&lang=js"
export * from "./SearchCardItem.vue?vue&type=script&lang=js"
import style0 from "./SearchCardItem.vue?vue&type=style&index=0&id=6a213695&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a213695",
  null
  
)

export default component.exports